import { render, staticRenderFns } from "./KomitmenKeselamatanTambang.vue?vue&type=template&id=8cd7dfc0&"
import script from "./KomitmenKeselamatanTambang.vue?vue&type=script&lang=js&"
export * from "./KomitmenKeselamatanTambang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports